import { Injectable } from '@angular/core';
import { ModalService } from '../../../core/services/modal/modal.service';
import { LogoutModalComponent } from '../../../shared/components/modal/logout-modal/logout-modal.component';

@Injectable({
  providedIn: 'root'
})
export class MainLayoutService {

  constructor(private modalService: ModalService) { }

  openLogoutModal() {
    this.modalService.openModal(LogoutModalComponent);
  }
}
